<template>
  <!--begin: User bar -->
  <component :is="mobileMenuOnly ? 'ul' : 'div'" :class="mobileMenuOnly ? 'my-account-wrapper navbar-nav m-0' : null">
    <template v-if="mobileMenuOnly">
      <template v-if="user && menu">
        <template v-for="menuItem in menuItems">
          <li v-if="menuItem.displayed !== false" :key="menuItem.id" class="navbar-nav-item d-lg-none pt-0 pb-2">
            <a v-if="menuItem.uri" :href="menuItem.uri" class="btn btn-sm btn-outline-primary btn-pill font-weight-bold">
              <i v-if="menuItem.icon" :class="menuItem.icon" class="mr-2"></i>
              <span>{{ menuItem.label }}</span>
              <span v-if="menuItem.badge" :class="['badge', menuItem.badge, 'ml-2']">{{ menuItem.badgeCount || 1 }}</span>
            </a>
            <span v-else class="btn btn-sm btn-outline-primary btn-pill font-weight-bold disabled">
              <i v-if="menuItem.icon" :class="menuItem.icon" class="mr-2"></i>
              <span>{{ menuItem.label }}</span>
              <span v-if="menuItem.badge" :class="['badge', menuItem.badge, 'ml-2']">{{ menuItem.badgeCount || 1 }}</span>
            </span>
          </li>
          <li
            v-for="child in visibleChildren(menuItem)"
            :key="child.id"
            class="navbar-nav-item d-lg-none pt-0 pb-2 pl-4"
          >
            <a v-if="child.uri" :href="child.uri" class="btn btn-sm btn-outline-primary btn-pill font-weight-bold">
              <i v-if="child.icon" :class="child.icon" class="mr-2"></i>
              <span>{{ child.label }}</span>
              <span v-if="child.badge" :class="['badge', child.badge, 'ml-2']">{{ child.badgeCount || 1 }}</span>
            </a>
            <span v-else class="btn btn-sm btn-outline-primary btn-pill font-weight-bold disabled">
              <i v-if="child.icon" :class="child.icon" class="mr-2"></i>
              <span>{{ child.label }}</span>
              <span v-if="child.badge" :class="['badge', child.badge, 'ml-2']">{{ child.badgeCount || 1 }}</span>
            </span>
          </li>
        </template>
        <li class="navbar-nav-item d-lg-none pt-0 pb-4">
          <a v-if="!user.impersonated" :href="path('fos_user_security_logout')" class="btn btn-sm btn-primary btn-pill font-weight-bold">
            {{ 'dict.logout'|trans }}
          </a>
          <a v-else :href="impersonationExitUrl()" class="btn btn-sm btn-danger btn-pill font-weight-bold">
            {{ 'layout.exit-impersonating'|trans }}
          </a>
        </li>
      </template>
      <li v-else-if="isAnonymousVisit" class="navbar-nav-item d-lg-none py-4">
        <a class="btn btn-sm btn-primary btn-pill font-weight-bold" :href="path('fos_user_security_login')">
          <svg class="align-middle mb-1 mr-3" xmlns="http://www.w3.org/2000/svg" width="10.882" height="13.852" viewBox="0 0 10.882 13.852">
            <g transform="translate(-80.04 -32)">
              <path data-name="Path 12" d="M90.922,230.535a7.427,7.427,0,0,0-1.607-4.684,4.9,4.9,0,0,0-7.667,0,7.425,7.425,0,0,0-1.607,4.678,13.256,13.256,0,0,0,5.441,1.387A12.107,12.107,0,0,0,90.922,230.535Z" transform="translate(0 -186.063)" fill="#fafafa"/>
              <circle data-name="Ellipse 1" cx="2.721" cy="2.721" r="2.721" transform="translate(82.76 32)" fill="#fafafa"/>
            </g>
          </svg>
          {{ 'layout.link.my_account' | trans({},'FOSUserBundle') }}
        </a>
      </li>
    </template>
    <!-- the AUTHENTICATED case -->
    <div v-else-if="user" class="metronic-scope d-none d-lg-flex justify-content-end">
      <!-- begin: user label -->
      <div class="topbar-item" data-offset="10px,0px" role="button" :class="{'user-border-right': notificationsActive || messagingActive}">
        <a class="btn btn-icon btn-clean btn-lg px-2" :class="{
              'text-success': !user.impersonated,
              'text-danger': user.impersonated,
           }"
           href="javascript:;" @click.prevent="gotoUserDashboard()"
        >
          <div v-if="useAvatars && avatar">
            <img v-if="avatar" :src="avatar" id="img-avatar-top">
            <img v-if="!avatar && (user.salutation === 'mr')"
                 src="/assets/global/img/heads-male.png" id="img-avatar-top" alt="">
            <img v-if="!avatar && (user.salutation !== 'mr')"
                 src="/assets/global/img/heads-female.png" id="img-avatar-top" alt="">
          </div>

          <span class="svg-icon svg-icon-xs mr-2" :class="{'svg-icon-success': !user.impersonated, 'svg-icon-danger': user.impersonated}">
            <svg xmlns="http://www.w3.org/2000/svg" width="6.449" height="8.21" viewBox="0 0 6.449 8.21">
              <g id="user" transform="translate(-80.04 -32)">
                <path id="Path_12" data-name="Path 12" d="M86.489,227.873a4.4,4.4,0,0,0-.952-2.776,2.9,2.9,0,0,0-4.544,0,4.4,4.4,0,0,0-.952,2.772,7.857,7.857,0,0,0,3.225.822A7.175,7.175,0,0,0,86.489,227.873Z" transform="translate(0 -188.482)" fill="#ffc700" />
                <circle id="Ellipse_1" data-name="Ellipse 1" cx="1.613" cy="1.613" r="1.613" transform="translate(81.652 32)" fill="#ffc700" />
              </g>
            </svg>
          </span>

          <span v-if="!user.impersonated" class="topbar-item--username">Witaj&nbsp;{{ (user.firstName ? '&nbsp;' + user.firstName : '') }}</span>
          <span v-if="user.impersonated" class="topbar-item--username">Witaj&nbsp;{{ (user.firstName ? '&nbsp;[' + user.firstName + ']' : '') }}</span>
        </a>
      </div>
      <!-- end: user label -->

      <topbar-user-notifications v-if="notificationsActive"></topbar-user-notifications>
      <topbar-unread-messages v-if="messagingActive"></topbar-unread-messages>

      <!-- begin: account menu -->
      <div class="dropdown">
        <div class="topbar-item" data-toggle="dropdown" data-offset="10px,0px" role="button">
          <div class="btn btn-icon btn-clean btn-dropdown btn-lg">
                                  <span class="svg-icon svg-icon-success svg-icon-xs">
                                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" style="transform: rotate(180deg);" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <path d="M3.95428417,19 L20.0457158,19 C20.3218582,19 20.5457158,18.7761424 20.5457158,18.5 C20.5457158,18.3982978 20.5147019,18.2990138 20.4568119,18.215395 L12.4110961,6.59380547 C12.2539131,6.36676337 11.9424371,6.31013137 11.715395,6.46731437 C11.6659703,6.50153145 11.623121,6.54438079 11.5889039,6.59380547 L3.54318807,18.215395 C3.38600507,18.4424371 3.44263707,18.7539131 3.66967918,18.9110961 C3.75329796,18.968986 3.85258194,19 3.95428417,19 Z" fill="#000000"/>
                                        </g>
                                      </svg>
                                  </span>
          </div>
        </div>
        <div class="dropdown-menu dropdown-menu-left dropdown-menu-md p-0">
          <div class="navi-header font-weight-bold py-5">
            <div class="btn btn-label-primary btn-sm btn-bold btn-font-md">{{'profile.show.currentPlan'|trans}}: <span :class="subscriptionColorClass" class="text-uppercase font-weight-bold">{{ trans('accounting.plan.' + currentSubscription.type + '.label', [], 'AppAccounting') }}</span></div>
            <a v-if="currentSubscription.type === 'free'" :href="path('app_account.accounting.subscription')"
               class="btn btn-clean btn-xs btn-bold ml-2">{{ 'profile.show.upgradePlan'|trans }}
            </a>
          </div>
          <div class="separator separator-solid mb-4"></div>
          <a v-if="menuLoginItem" :href="menuLoginItem.uri" class="kt-notification__item">
            <div v-if="menuLoginItem.icon" class="kt-notification__item-icon mr-2">
              <i :class="menuLoginItem.icon"></i>
            </div>
            <div class="kt-notification__item-details">
              <div class="kt-notification__item-title kt-font-bold">
                {{ menuLoginItem.label }}
              </div>
            </div>
          </a>
          <ul class="navi">
            <template v-for="menuItem in menuItems">
              <li v-if="menuItem.displayed !== false" :key="menuItem.id" :class="menuItemClass(menuItem)">
                <a v-if="menuItem.uri" :href="menuItem.uri" :class="menuItemLinkClass(menuItem)">
                  <i v-if="menuItem.icon" :class="menuItem.icon" class="mr-2"></i>
                  <span>{{ menuItem.label }}</span>
                  <span v-if="menuItem.badge" :class="['badge', menuItem.badge]">{{ menuItem.badgeCount || 1 }}</span>
                </a>
                <span v-else :class="menuItemLabelClass(menuItem)">
                  <i v-if="menuItem.icon" :class="menuItem.icon"></i>
                  <span>{{ menuItem.label }}</span>
                  <span v-if="menuItem.badge" :class="['badge', menuItem.badge]">{{ menuItem.badgeCount || 1 }}</span>
                </span>
                <ul v-if="hasChildren(menuItem)" class="navi">
                  <li v-for="child in menuItem.children" v-if="child.displayed !== false" :key="child.id" :class="menuItemClass(child)">
                    <a v-if="child.uri" :href="child.uri" :class="menuItemLinkClass(child)">
                      <i v-if="child.icon" :class="child.icon" class="mr-2"></i>
                      <span>{{ child.label }}</span>
                      <span v-if="child.badge" :class="['badge', child.badge]">{{ child.badgeCount || 1 }}</span>
                    </a>
                    <span v-else :class="menuItemLabelClass(child)">
                      <i v-if="child.icon" :class="child.icon" class="mr-2"></i>
                      <span>{{ child.label }}</span>
                      <span v-if="child.badge" :class="['badge', child.badge]">{{ child.badgeCount || 1 }}</span>
                    </span>
                  </li>
                </ul>
              </li>
            </template>
          </ul>
          <div class="separator separator-solid mt-4"></div>
          <div class="navi-footer py-5 d-flex justify-content-center">
            <a v-if="!user.impersonated" :href="path('fos_user_security_logout')"
               class="btn btn-outline-primary btn-pill">{{ 'dict.logout'|trans }}</a>
            <div v-if="user.impersonated">
              <a :href="impersonationExitUrl()"
                 class="btn btn-danger btn-pill">{{ 'layout.exit-impersonating'|trans }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- end: account menu -->
    </div>
    <!-- the ANONYMOUS case -->
    <div v-else-if="!mobileMenuOnly && !user" class="d-none d-lg-block">
      <a :href="path('fos_user_security_login')" class="header-login font-weight-medium">
        {{ 'layout.link.my_account' | trans({},'FOSUserBundle') }}
      </a>
    </div>
  </component>
  <!--end: User bar -->
</template>

<script>

import Axios from 'axios';
import securityUtil from '@/core/utils/security';
import globalConfig from '@/core/config/app';
import guiUtil from '@/core/utils/gui';
import HttpUtil from '@/core/utils/http';
import Subscription from '@/accounting/models/Subscription';
import Translator from 'bazinga-translator';
import store from '@/core/services/store';
import {
  SET_USER_DATA,
  SET_USER_MENU,
  SET_USER_AVATAR,
  SET_CURRENT_SUBSCRIPTION,
  SET_ACL,
} from '@/core/services/store/profile.module';
import ApiService from '@/core/services/api.service';
import TopbarUserNotifications from './topbar-user-notifications.vue';
import TopbarUnreadMessages from './topbar-unread-messages.vue';

export default {
  name: 'TopbarUserProfile',
  store: store,
  components: {
    TopbarUserNotifications,
    TopbarUnreadMessages
  },
  props: {
    useAvatars: {
      type: Boolean,
      default: false,
    },
    marketplaceActive: {
      type: Boolean,
      default: false,
    },
    notificationsActive: {
      type: Boolean,
      default: false,
    },
    messagingActive: {
      type: Boolean,
      default: false,
    },
    mobileMenuOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: null,
      menu: null,
      avatar: null,
      currentSubscription: new Subscription(),
      isImpersonated: false,
      acl: null,
    };
  },
  computed: {
    unreadMessagesCount() {
      return 5;
    },
    messageBoxUrl() {
      return JsRouting.generate('app_my_messages', {}, true);
    },
    isAuthenticated() {
      return securityUtil.isAuthenticatedSession();
    },
    isAnonymousVisit() {
      return this.$store.getters.isAnonymousVisit;
    },
    subscriptionColorClass() {
      let cssClass = '';
      switch (this.currentSubscription.type) {
        case 'free': cssClass = 'text-success'; break;
        case 'basic': cssClass = 'text-secondary'; break;
        case 'premium': cssClass = 'text-primary'; break;
        default: cssClass = 'text-success';
      }
      return cssClass;
    },
    menuItems() {
      if (!this.menu || !Array.isArray(this.menu.items)) {
        return [];
      }
      return this.menu.items;
    },
    menuLoginItem() {
      if (!this.menu) {
        return null;
      }
      if (this.menu.loginItem) {
        return this.menu.loginItem;
      }
      if (this.menu.loginLink) {
        return {
          label: 'Login',
          uri: this.menu.loginLink,
          icon: 'flaticon2-calendar-3 kt-font-success',
        };
      }
      return null;
    },
  },
  watch: {
  },
  created() {
  },
  mounted() {
    try {
      this.init();
    } catch (error) {
      throw new Error(error);
    }
  },
  methods: {
    init() {
      const self = this;
      this.captureImpersonationReturnUrl();
      if (!self.$store.getters.isAnonymousVisit && self.$store.state.profile.userData == null) {
        this.fetchContent().done((remoteData) => {
          if (remoteData) {
            this.acl = (remoteData.acl ? remoteData.acl : (securityUtil.getAcl() || []));
            this.user = remoteData.user || null;
            this.currentSubscription = remoteData.current_subscription ? new Subscription(remoteData.current_subscription) : null;
            this.menu = remoteData.menu || null;
            this.avatar = remoteData.avatar || null;
            // commit everything into global state
            self.$store.commit(SET_USER_DATA, this.user);
            self.$store.commit(SET_CURRENT_SUBSCRIPTION, this.currentSubscription);
            self.$store.commit(SET_USER_MENU, this.menu);
            self.$store.commit(SET_USER_AVATAR, this.avatar);
            self.$store.commit(SET_ACL, this.acl);
          }
          self.$nextTick(() => {
            self.initPlugins();
          });
        });
      } else {
        // fetch all user data from global state
        this.user = self.$store.state.profile.userData;
        this.currentSubscription = self.$store.state.profile.currentSubscription;
        this.menu = self.$store.state.profile.userMenu;
        this.avatar = self.$store.state.profile.userAvatar;
        this.acl = self.$store.state.profile.acl;
        self.$nextTick(() => {
          self.initPlugins();
        });
      }
    },

    initPlugins() {

    },

    trans(key, params, domain, multipleCount) {
      if (multipleCount) {
        return Translator.transChoice(key, multipleCount, params || {}, domain || 'FOSUserBundle');
      } else {
        return Translator.trans(key, params || {}, domain || 'FOSUserBundle');
      }
    },

    path(path, params) {
      const _params = params || {};
      return JsRouting.generate(path, _params, true);
    },

    impersonationExitUrl() {
      const fallback = this.path('fos_user_account', {'_switch_user': '_exit'});
      const returnUrl = this.getImpersonationReturnUrl();
      if (!returnUrl) {
        return fallback;
      }

      const separator = returnUrl.indexOf('?') === -1 ? '?' : '&';
      return `${returnUrl}${separator}_switch_user=_exit`;
    },

    captureImpersonationReturnUrl() {
      try {
        const params = new URLSearchParams(window.location.search || '');
        const candidate = (params.get('_impersonation_return') || '').trim();
        if (!candidate) {
          return;
        }

        if (!candidate.startsWith('/')) {
          return;
        }

        window.localStorage.setItem('impersonation_return_url', candidate);
      } catch (error) {
        // no-op, fallback URL will be used
      }
    },

    getImpersonationReturnUrl() {
      try {
        const value = (window.localStorage.getItem('impersonation_return_url') || '').trim();
        if (!value || !value.startsWith('/')) {
          return null;
        }
        return value;
      } catch (error) {
        return null;
      }
    },

    gotoUserDashboard() {
      const url = JsRouting.generate('fos_user_account', {}, true);
      document.location.href = url;
    },

    hasChildren(menuItem) {
      return !!(menuItem && Array.isArray(menuItem.children) && menuItem.children.length);
    },

    visibleChildren(menuItem) {
      if (!this.hasChildren(menuItem)) {
        return [];
      }
      return menuItem.children.filter((child) => child.displayed !== false);
    },

    menuItemClass(menuItem) {
      if (Array.isArray(menuItem.classes) && menuItem.classes.length) {
        return menuItem.classes.join(' ');
      }
      if (menuItem.attributes && menuItem.attributes.class) {
        return menuItem.attributes.class;
      }
      return '';
    },

    menuItemLinkClass(menuItem) {
      if (menuItem.linkAttributes && menuItem.linkAttributes.class) {
        return menuItem.linkAttributes.class;
      }
      return '';
    },

    menuItemLabelClass(menuItem) {
      if (menuItem.labelAttributes && menuItem.labelAttributes.class) {
        return menuItem.labelAttributes.class;
      }
      return '';
    },

    /**
     * Fetch use session data from remote
     */
    fetchContent() {
      const def = $.Deferred();
      const self = this;
      const url = JsRouting.generate(ApiService.apiRoute('webapi_session_get_init_data'), {}, true);

      Axios.get(url).then((response) => {
        def.resolve(response.data);
      }).catch((error) => {
        HttpUtil.axiosErroDefaultHandler(error).done((errorString) => {
        });
        // do nothing
        def.reject();
      });
      return def;
    },

  }
}
</script>

<style scoped>

</style>
